import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { Container, SectionTitle } from 'chaoskit/src/components'
import { tealGreen } from 'chaoskit/src/assets/styles/utility/gradient'

import Image from '~components/Image'
import ButtonLink from '~components/ButtonLink'

const IndustryTopCTA = ({ image, heading, cta }) => {
  const theme = useTheme()

  return (
    <div
      className={theme.settings.classes.contrast}
      css={[
        tealGreen(theme),
        {
          overflow: 'hidden',
        },
      ]}
    >
      <Container>
        <div
          css={{
            display: 'grid',
            gap: theme.space.large,

            [theme.mq.medium]: {
              gridTemplateColumns: '2fr 1.5fr',
              gap: theme.space.xlarge,
            },
          }}
        >
          <div
            css={{
              paddingTop: theme.space.xlarge,

              [theme.mq.medium]: {
                paddingBottom: theme.space.xlarge,
              },
            }}
          >
            <SectionTitle as="h2" align={{ medium: 'left' }} title={heading} />
            <div
              css={{
                [theme.mq.small__max]: {
                  textAlign: 'center',
                },
              }}
            >
              <ButtonLink type="default" url={cta.url}>
                {cta.label}
              </ButtonLink>
            </div>
          </div>
          <div
            css={{
              alignSelf: 'end',
            }}
          >
            <Image
              css={{
                [theme.mq.medium]: {
                  transform: 'translateY(25%)',
                },
              }}
              src={image}
            />
          </div>
        </div>
      </Container>
    </div>
  )
}

IndustryTopCTA.propTypes = {
  cta: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}

export default IndustryTopCTA
